import React, { Component } from 'react';
import styled from 'styled-components';
import { keyframes } from 'styled-components';

const CheckEmailAnimation = () => {
 return (
  <AnimatedContainer>
    <AnimatedImage src='https://zervicepoint.com/wp-content/uploads/sign-up/youvegotmail.png' />
  </AnimatedContainer>
 )
}

export default CheckEmailAnimation
export const checkEmailAnimation = keyframes`
  0%, 20%, 40%, 60%, 80%, 100% {-webkit-transform: translateY(5);}
  30% {-webkit-transform: translateY(-12px);}
`;

const AnimatedImage = styled.img`
  position: relative;
  animation-name: ${checkEmailAnimation};
  animation-duration: 4s;
  animation-iteration-count: infinite;
`;

const AnimatedContainer = styled.div`
 display: flex;
 align-items: center;
 justify-content: center;
 flex-direction: column;
 height: 250px;
`;
